<template>
  <div
    v-loading="loading"
    class="messagesCard"
  >
    <div class="messagesCard__header">
      <h4>{{$t('messages.view.title')}}</h4>
      <p>{{$t('messages.view.subtitle')}}</p>
    </div>
    <div class="messagesCard__content">
      <messages-content v-if="!loading" />
    </div>
    <div class="messagesCard__footer">
      <messages-form />
    </div>
  </div>
</template>

<script>
import MessagesForm from "@/components/records/messages/MessagesForm"
import MessagesContent from "@/components/records/messages/MessagesContent"

export default {
  name: "RecordsMessages",
  components: {
    MessagesForm,
    MessagesContent
  },
  data: () => ({
    loading: false
  }),
  async mounted() {
    try {
      this.loading = true
      await this.$store.dispatch('records/getMessages')
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.messagesCard';

#{$c} {
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(154, 147, 140, 0.33);
  border-radius: $--border-radius-base;

  &__header {
    border-bottom: 1px solid $--border-color-light;
    box-shadow: $--box-shadow-base;
  }
  &__header h4 {
    padding: 24px 24px 0px 24px;
    font-size: 22px;
  }
  &__header p {
    padding: 0 24px;
    font-size: 16px;
  }
  &__footer {
    padding: 24px;
    border-top: 1px solid $--border-color-light;
    box-shadow: $--box-shadow-base;
  }
}
</style>